/* sf-atajo
 * Le agrega al enlace del boton de acceso directo lo que el comprador ya eligio, para que la
 * publicacion de destino abra en el mismo lugar y no lo haga elegir dos veces.
 *
 * Reusa los parametros que ya existen desde los enlaces de Instagram
 * (sticker-color-selector.js, applyDeepLink):
 *
 *     ?color=C06    ?color2=A02    ?combo=<ref>
 *
 * Dos cosas que ya estan resueltas del otro lado y por eso aca no se controlan:
 *   - si el destino tiene UN selector menos, applyDeepLink descarta `color2` solo
 *     (`if (i === 1 && !this.secondActive()) return;`). No da error.
 *   - un codigo que ya no existe se ignora y la ficha abre normal.
 *
 * Se arma en el momento del clic, no al cargar: el comprador puede cambiar de color despues
 * de que la pagina se dibujo, y un href calculado al inicio lo mandaria al color viejo.
 */
(function () {
  'use strict';

  function selector() {
    return document.querySelector('sticker-color-selector');
  }

  /** Devuelve los parametros de la seleccion actual, o null si no hay nada que llevar. */
  function seleccion() {
    var el = selector();
    if (!el) return null;

    var p = new URLSearchParams();

    // Una combinacion ya trae los dos colores, asi que va sola y gana.
    // Del otro lado `combo` se aplica primero y hace return, asi que mandar ademas
    // `color` seria ruido: se ignora igual.
    var combo = el.combo;
    if (combo) {
      var ref = String(combo.ref || combo.id || '').trim();
      if (ref) {
        p.set('combo', ref);
        return p;
      }
    }

    var st = el.state;
    if (!st || !st.color) return null;

    var c1 = st.color[0];
    var c2 = st.color[1];
    if (c1) p.set('color', String(c1));
    if (c2) p.set('color2', String(c2));

    return p.toString() ? p : null;
  }

  function alClic(ev) {
    var a = ev.currentTarget;
    if (a.getAttribute('data-llevar') !== '1') return;

    var destino = a.getAttribute('data-destino') || a.getAttribute('href');
    if (!destino) return;

    var p;
    try {
      p = seleccion();
    } catch (e) {
      return; // ante cualquier duda el enlace simple sigue funcionando
    }
    if (!p) return;

    var url;
    try {
      url = new URL(destino, window.location.origin);
    } catch (e) {
      return;
    }
    p.forEach(function (v, k) {
      url.searchParams.set(k, v);
    });

    a.setAttribute('href', url.pathname + url.search);
  }

  /* --- Cliente 2026-09-16: en que pestañas se muestra el bloque ---
   *
   * El selector avisa con `scs:vista` cada vez que el comprador cambia de pestaña o de opcion,
   * y trae 'simil' / 'disponibles' / 'elegir'. Aca solo se traduce a mostrar o esconder.
   *
   * En un producto SIN selector (accesorios, llaveros, stickers) no hay pestañas ni evento, asi
   * que el bloque se muestra siempre: apagarlo ahi seria esconderlo sin que nadie lo haya pedido.
   *
   * Se compara antes de escribir. `scs:vista` ya viene deduplicado del otro lado, pero esta es
   * la garantia que importa: este script no puede quedar escribiendo el DOM en un bucle. */
  function aplicarVista(vista) {
    document.querySelectorAll('.sf-atajo[data-sf-atajo-vis]').forEach(function (caja) {
      var quiero = caja.getAttribute('data-en-' + vista) === '1';
      if (caja.hidden === !quiero) return;
      caja.hidden = !quiero;
    });
  }

  function vistaDelSelector() {
    var el = selector();
    if (!el || typeof el.vistaActual !== 'function') return null;
    try {
      return el.vistaActual();
    } catch (e) {
      return null;
    }
  }

  /* El elemento `sticker-color-selector` se define y arranca en su propio script, y no hay
   * garantia de que ya este vivo cuando corre este. Si todavia no lo esta, `vistaActual()` no
   * existe y la primera lectura da null.
   *
   * No alcanza con esperar el evento: `anunciarVista()` no repite la misma vista, asi que si su
   * primer aviso salio antes de que este script enganchara el oyente, no vuelve a salir hasta
   * que el comprador cambie de pestaña, y mientras tanto el bloque se veria donde no va.
   *
   * Por eso se reintenta unas pocas veces y se corta apenas hay respuesta. Son 4 lecturas
   * acotadas, sin observadores y sin escribir nada mientras no haya un valor de verdad. */
  var REINTENTOS = [0, 120, 400, 1200];

  function sincronizarVista(i) {
    var v = vistaDelSelector();
    if (v) {
      aplicarVista(v);
      return;
    }
    // Sin selector en la pagina no hay pestañas: el bloque se queda como vino del servidor.
    var n = (i || 0) + 1;
    if (n < REINTENTOS.length) setTimeout(function () { sincronizarVista(n); }, REINTENTOS[n]);
  }

  document.addEventListener('scs:vista', function (ev) {
    var v = ev && ev.detail && ev.detail.vista;
    if (v) aplicarVista(v);
  });

  function enganchar() {
    sincronizarVista();
    document.querySelectorAll('a[data-sf-atajo]').forEach(function (a) {
      if (a.dataset.sfAtajoListo === '1') return;
      a.dataset.sfAtajoListo = '1';
      // `click` alcanza: corre antes de que el navegador siga el enlace, asi que
      // reescribir el href aca ya cambia a donde va.
      a.addEventListener('click', alClic);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enganchar);
  } else {
    enganchar();
  }

  // El editor de temas vuelve a dibujar la seccion sin recargar la pagina.
  document.addEventListener('shopify:section:load', enganchar);
})();
